const { z } = require('zod')

export const ROUND_CLOSE_TYPE = {
  ROUND_CLOSE: 'round-close',
  TEMPORARY_ROUND_CLOSE: 'temporary-round-close',
}

const roundCloseTypeEnum = z.enum([ROUND_CLOSE_TYPE.ROUND_CLOSE, ROUND_CLOSE_TYPE.TEMPORARY_ROUND_CLOSE])

const openTimeSchema = z
  .string()
  .superRefine((val, ctx) => {
    if (isNaN(Date.parse(val))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'กรุณากรอกเวลาเปิดรอบถัดไปให้ถูกต้อง',
      })
    } else if (new Date(val) < new Date()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'เวลาเปิดรอบต้องมากกว่าเวลาปัจจุบัน',
      })
    }
  })
  .transform((val) => new Date(val).toISOString())

export const schema = z.discriminatedUnion('roundCloseType', [
  z.object({
    roundCloseType: roundCloseTypeEnum.extract([ROUND_CLOSE_TYPE.TEMPORARY_ROUND_CLOSE]),
    title: z.string().min(1, 'กรุณากรอกหัวข้อ'),
    description: z.string().optional(),
    isSchedule: z.boolean().default(false),
    openTime: openTimeSchema,
  }),
  z.object({
    roundCloseType: roundCloseTypeEnum.extract([ROUND_CLOSE_TYPE.ROUND_CLOSE]),
    title: z.string().optional(),
    description: z.string().optional(),
    isSchedule: z.boolean().default(false),
    openTime: openTimeSchema,
  }),
])

export const imageSchema = z.object({
  url: z.string().or(z.instanceof(FileList).refine((val) => val.length > 0, 'กรุณาอัปโหลดไฟล์')),
})


export const prizesShareCampaignSchema = z.object({
  prizeTypes: z.array(z.string()).min(1, 'กรุณาเลือกประเภทของรางวัล'),
  limit: z
    .preprocess(
      (val) => (!val ? undefined : typeof val === 'string' ? Number(val) : val),
      z.number({ required_error: 'กรุณาระบุจำนวน' }).min(1, 'กรุณาระบุจำนวนที่ถูกต้อง')
    ),
  imageUrl: z.string().or(z.instanceof(FileList).refine((val) => val.length > 0, 'กรุณาอัปโหลดไฟล์')),
  description: z.string().optional(),
})
